import { Link } from "react-router-dom";

const sections = [
  {
    title: "Who we are",
    body: [
      "The Woodworkers Shed is a small workshop based in Whangamata, Aotearoa New Zealand, run by Hayden. This page explains what information we collect when you use our website (thewoodworkersshed.co.nz), how we use it, and the choices you have.",
      "If you have any questions about this policy, please email us at thewoodworkersshed@outlook.co.nz.",
    ],
  },
  {
    title: "Information we collect",
    body: [
      "When you submit our contact or commission form, we ask for your name, email address, and a description of your enquiry. You may optionally provide a phone number, project type, preferred timber, dimensions, budget and timeline. We only collect what you choose to share.",
      "Like most websites, our hosting and analytics tools record basic technical information such as IP address, browser type, device, and the pages you visit. This helps us understand how the site is used and keep it running smoothly.",
    ],
  },
  {
    title: "How we use your information",
    body: [
      "We use the details you submit to reply to your enquiry, prepare a quote, and (if you proceed) deliver the piece you commission. We do not sell, rent, or trade your information with third parties.",
      "We may use your email address to follow up about an open enquiry. We will only send broader updates if you explicitly opt in.",
    ],
  },
  {
    title: "Where your data is stored",
    body: [
      "Enquiry data is stored securely in a database hosted on managed cloud infrastructure. Access is restricted to the workshop. We retain enquiry records for as long as is reasonably necessary to respond, fulfil orders, and meet any legal or tax obligations.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "We use a small number of essential cookies and analytics tools to run the site and understand site usage. You can clear or block cookies via your browser settings at any time — the site will continue to work without them.",
    ],
  },
  {
    title: "Your rights",
    body: [
      "You can ask us at any time to see, correct, or delete the personal information we hold about you. Email thewoodworkersshed@outlook.co.nz and we'll action your request within a reasonable timeframe.",
    ],
  },
  {
    title: "Children",
    body: [
      "Our site and products are intended for adults. We do not knowingly collect information from children under 16.",
    ],
  },
  {
    title: "Changes to this policy",
    body: [
      "We may update this policy from time to time as the business or the law changes. The latest version will always live at this page. Material changes will be flagged on the homepage.",
    ],
  },
  {
    title: "Contact",
    body: [
      "The Woodworkers Shed",
      "Whangamata, Aotearoa New Zealand",
      "thewoodworkersshed@outlook.co.nz",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="max-w-[900px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-24">
      <header className="mb-14">
        <div className="eyebrow mb-5">Privacy</div>
        <h1 className="font-serif text-5xl md:text-6xl leading-[1.02] tracking-tight">
          Privacy policy.
        </h1>
        <p className="mt-6 text-sm text-[#6F4E37]">
          Last updated: 24 May 2026
        </p>
      </header>

      <div className="space-y-12">
        {sections.map((s) => (
          <section key={s.title} data-testid={`privacy-section-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <h2 className="font-serif text-2xl md:text-3xl mb-4 tracking-tight">{s.title}</h2>
            <div className="space-y-4 text-[#2C2421]/85 leading-relaxed">
              {s.body.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-16 border-t border-[#E5E0D8] pt-8 text-sm text-[#6F4E37]">
        Need anything else?{" "}
        <Link to="/contact" data-testid="privacy-contact-link" className="link-underline text-[#2C2421]">
          Get in touch
        </Link>
        .
      </div>
    </div>
  );
}
